import Vue, { DirectiveBinding } from 'vue'

interface BlurDirectiveOptions {
  isEnabled?: boolean,
  value?: string
}

const blurDirective = {
  bind(el: HTMLElement, binding: DirectiveBinding<BlurDirectiveOptions>) {
    const {
      isEnabled,
      value
    } = binding.value
    if (!isEnabled) {
      return
    }
    el.style.filter = `blur(${value})`
  }
}

Vue.directive('blur', blurDirective)
